import script from "./ranking.vue?vue&type=script&setup=true&lang=js"
export * from "./ranking.vue?vue&type=script&setup=true&lang=js"

import "./ranking.vue?vue&type=style&index=0&id=12ab6302&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12ab6302"]])

export default __exports__